// @ts-nocheck

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Editor from '../../../../Editor/Editor';
import './AdditionalInformation.css';
import { TenantSettingsPropTypes } from '../types';
import { getOldCoverImageUrl } from '../../../../../utils/getCoverImageUrl';

const AdditionalInformation = ({ content, tenantsettings }) => {
  const { t } = useTranslation('common');
  const hideImagesInPdf = tenantsettings?.showImagesInPdf === false;

  // Do not display if there is no content or if it is empty
  if (!content || !Array.isArray(content) || content.length === 0) {
    return null;
  }

  // Filter content that actually has information
  const validContent = content.filter(
    (item) =>
      (item.title && item.title.trim() !== '') ||
      (item.description && item.description.trim() !== '')
  );

  // Do not display if there is no valid content
  if (validContent.length === 0) {
    return null;
  }

  return (
    <div
      className='additional-information'
      fontFamily={tenantsettings?.bodyfont || 'inherit'}
    >
      <Typography
        variant='h4'
        fontWeight='bold'
        className='additional-information__title'
        style={{
          fontFamily: tenantsettings?.headingfont || 'inherit'
        }}
      >
        {t('Additional Information')}
      </Typography>

      {validContent.map(
        ({ tripcontentid, title, description, tripcontentimage }) => {
          const hasImage = tripcontentimage.length > 0;
          const imageUrl = hasImage ? tripcontentimage[0].imageurl : null;

          return (
            <div key={tripcontentid} className='additional-information__item'>
              {/* First row: Title spanning the entire width */}
              <div className='additional-information__title-row'>
                <h3
                  style={{
                    fontFamily: tenantsettings?.headingfont || 'inherit'
                  }}
                  className='additional-information__title-column'
                >
                  {title}
                </h3>
              </div>

              {/* Second row: Description (70%) and Image (30%) */}
              <div className='additional-information__content-row'>
                <div
                  className={`additional-information__description ${!imageUrl ? 'additional-information__description--full' : ''} ${hideImagesInPdf ? 'print__full-description' : ''}`}
                >
                  <Editor
                    id={`service-section-restaurant-${tripcontentid}-description`}
                    content={description}
                    editable={false}
                    isPreviewing={true}
                    className='additional-information__description__editor'
                    style={{
                      fontFamily: tenantsettings?.bodyfont || 'inherit'
                    }}
                  />
                </div>

                {hasImage && imageUrl && (
                  <div
                    className={`additional-information__image ${hideImagesInPdf ? 'noprint' : ''}`}
                  >
                    <img src={getOldCoverImageUrl(imageUrl)} alt={title} />
                  </div>
                )}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

AdditionalInformation.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      tripcontentid: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      tripcontentimage: PropTypes.arrayOf(
        PropTypes.shape({
          tripcontentimageid: PropTypes.number.isRequired,
          seq: PropTypes.number.isRequired,
          imageurl: PropTypes.string.isRequired
        })
      )
    })
  ),
  tenantsettings: TenantSettingsPropTypes,
  tripid: PropTypes.number,
  tenantid: PropTypes.number
};

export default AdditionalInformation;
